import { isValid, parseISO } from 'date-fns'

/**
 * Дата отзыва из SSR-строки.
 *
 * Django отдаёт datetime с пробелом вместо `T` (`2026-03-05 19:40:00`),
 * и `parseISO` без замены возвращает Invalid Date.
 */
export default function parseReviewDate(value?: string | Date | null): Date | null {
  if (!value) {
    return null
  }

  if (value instanceof Date) {
    return isValid(value) ? value : null
  }

  const isoLike = value.includes('T') ? value : value.replace(' ', 'T')
  const parsedIso = parseISO(isoLike)

  if (isValid(parsedIso)) {
    return parsedIso
  }

  const parsed = new Date(value)

  return isValid(parsed) ? parsed : null
}
